<template>
    <slot name="target" :show="clicked"></slot>
    <ModalView v-model:active="viewing">
        <template v-slot:body>
            <div v-if="identifier.player">
                <h3 class="mb-2">{{ translate("player") }}</h3>
                <PlayerView :player="identifier.player"/>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-4">
                <h3 class="d-flex align-items-center g-3 mb-0">
                    <i :class="identifier.type.icon" class="fa-lg"></i>
                    <span>{{ identifier.type.title }}</span>
                </h3>
                <ModalCloseButtonView @click="viewing = false"/>
            </div>
            <PlayerIdentifierDetailsView :identifier-id="identifier.id"/>
        </template>
    </ModalView>
</template>

<script setup>
import {ModalView, ModalCloseButtonView} from "@niftybit/vue";
import PlayerIdentifierDetailsView from "@/systems/modules/players/identifiers/PlayerIdentifierDetailsView.vue";
import authorization from "@/authorization";
import {ref, watch} from "vue";
import {useRoute} from "vue-router";
import PlayerView from "@/components/other/PlayerView.vue";

defineProps({
  identifier: Object
});

const viewing = ref(false);

function clicked() {
  if (!authorization.permission("community.players.view")) return;
  viewing.value = true;
}

const route = useRoute();

watch(route, () => viewing.value = false);

</script>